export default {
  client: { value: 'client', text: 'Client' },
  server: { value: 'server', text: 'Server' },
};
